<template>
    <ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-button color="medium" @click="cancel">Annulla</ion-button>
            </ion-buttons>
            <ion-title>{{ title }}</ion-title>
            <ion-buttons slot="end">
                <ion-button @click="submit" :strong="true">Conferma</ion-button>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" style="--background: var(--ion-item-background)">
        <ion-header collapse="condense">
            <ion-toolbar style="--background: var(--ion-item-background)">
                <ion-title slot="start" class="w-full text-left" style="padding-inline: 0">
                    <h1 class="font-bold">
                        {{ title }}
                    </h1>
                </ion-title>
            </ion-toolbar>
        </ion-header>
        <form class="">
            <form-input
                v-model="name"
                v-model:valid="nameValid"
                :rules="[Validation.required]"
                label="Nome Area"></form-input>
            <div
                class="w-full ion-margin-vertical"
                style="background-color: var(--ion-color-step-150); padding: 8px; border-radius: 8px">
                <ion-label>Colore</ion-label>
                <div class="flex ion-align-items-center ion-margin-top-half" style="gap: 12px">
                    <input
                        type="color"
                        v-model="color"
                        style="
                            width: 50px;
                            height: 50px;
                            border: none;
                            border-radius: 8px;
                            cursor: pointer;
                            padding: 0;
                        " />
                    <div
                        style="
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                            border: 2px solid var(--ion-color-step-600);
                        "
                        :style="{ 'background-color': color }"></div>
                    <ion-note>{{ color }}</ion-note>
                </div>
            </div>
            </form>
    </ion-content>
</template>

<script setup lang="ts">
import {
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonLabel,
    IonNote,
    IonTitle,
    IonToolbar,
    modalController,
} from "@ionic/vue";
import FormInput from "@/components/FormInput.vue";
import { computed, PropType, ref } from "vue";
import { IZone } from "@/types/zone";
import { useCostumersStore } from "@/stores/costumers";
import { Validation } from "@/utility";

const props = defineProps({
    zone: {
        type: Object as PropType<IZone>,
        required: false,
    },
});

const costumerStore = useCostumersStore();
const zoneId = props.zone ? props.zone.id : -Math.round(Date.now() / 1000);

const name = ref<string>(props.zone?.name ?? "");
const nameValid = ref<boolean>(props.zone ? !!props.zone.name : true);
const color = ref<string>(props.zone?.color ?? "#3880ff");

const title = computed(() => {
    return zoneId >= 0 ? "Modifica Area" : "Nuova Area";
});

const cancel = () => {
    return modalController.dismiss(null, "cancel");
};

const submit = async () => {
    if (!nameValid.value || !name.value) {
        return;
    }

    const zoneData: Partial<IZone> = {
        name: name.value,
        color: color.value,
    };

    if (zoneId >= 0) {
        await costumerStore.updateZone({ ...zoneData, id: zoneId } as IZone);
    } else {
        await costumerStore.createZone(zoneData as IZone);
    }
    return modalController.dismiss(null, "confirm");
};
</script>
